<template lang="pug">

  .step(ref="step") 
    slot

</template>

<script>   
import TweenMax from "gsap";   
 
export default {
  
  name: 'split-text',
  
  components: {},
  
  data () {
    return {

    }
  },
  
  props: {
    delay: Number,
    type: String,
    classname: String
  },
  
  computed: {},

  mounted () { 
    console.log(this.type)
    let mySplitText = new SplitText(this.$refs.step, {type: this.type, wordsClass: this.classname })

    // for (var i = 0; i < mySplitText.lines.length; i++) {
    //   TweenMax.fromTo(mySplitText.lines[i], 0.9 + (i * 0.05), {
    //     'y': 200,
    //     'opacity': 0,
    //     'force3D': true
    //   }, {
    //     'y': 0,
    //     'opacity': 1,
    //     'delay': this.delay + 0.7 + (i * 0.1),
    //     'ease': 'Power3.easeOut'
    //   })
    // }

    setTimeout(() => {
      this.$emit('ready');
    }, 200);
  },

  beforeDestroy () {

  },

  methods: {

  },

  watch: {

  }

}
</script>

<style lang="sass">
@import "src/styles/common.sass"
  
</style>
